<script lang="ts">
  import AuthLayout from "./AuthLayout.svelte";
  import Button from "$lib/components/Button.svelte";
</script>

<AuthLayout title="You're signed out" subtitle="Your session has ended.">
  <Button href="/login" fullWidth>Sign in again</Button>
</AuthLayout>
